import { Button, Text, Title, Tag } from '@kaleyra/kds'
import React from 'react'
import Styles from './AdvanceFilter.module.scss'

type advanceFilterProps = {
    title : string,
    subtitle : string,
    buttonName : string,
    pills ?: {label : string, value : string}[]
    handleButtonClick ?: () => void
    handlePillClose :(label : string)=>void
}
const AdvanceFilter : React.FC<advanceFilterProps> = ({
    title,
    subtitle,
    buttonName,
    pills,
    handleButtonClick,
    handlePillClose
}) => {
  return (
   <div className='w-100 mt-2'>
        <div className='w-100 d-flex flex-row align-items-center justify-content-between'>
            <div className='d-flex flex-column'>
                <Title weight='400'>{title}</Title>
                <Text weight='300'>{subtitle}</Text>
            </div>
            <Button onClick={handleButtonClick}>{buttonName}</Button>
        </div>
        <div className={Styles.filterPillWrapper}>
            {
                pills && pills?.map((pill)=>{
                    return(     
                    pill.value &&
                    <Tag 
                        showClippedNumber
                        closable
                        type='info'
                        onClose={()=>{handlePillClose(pill.label)}}
                        key={pill.label}
                    >
                        {pill.label} : {pill.value}
                    </Tag>
                         
                    )
                })
            }
        </div>
   </div>
  )
}

export default AdvanceFilter